import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewSupplier} from "../../../../_reducers/activitySlice";
import {Col, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import {setNewSupplier} from "../../../../_reducers/DataPanel/Suppliers/supplierSlice";

const NewSupplierAccounting = () => {
    const dispatch = useDispatch();
    const saveNewSupplier = useSelector((state) => state.ACTIVITY.saveNewSupplier);
    const newSupplier = useSelector((state) => state.SUPPLIERS_DATA.newSupplier);

    const handleOnChange = (e, type, compName) => {
        if (!saveNewSupplier) dispatch(setSaveNewSupplier(true));
        if (type === "input") {
            if (compName === "accounting") {
                dispatch(setNewSupplier({...newSupplier, accounting: e.target.value}));
            } else if (compName === "bypassAccounting") {
                dispatch(setNewSupplier({...newSupplier, bypassAccounting: e.target.value}));
            }
        }
    }
    return (
        <React.Fragment>
            <Row>
                <Col md={4}>
                    <Input
                        name="accounting"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                        label="Πρόθεμα Κωδικού Λογαριασμού"
                        value={newSupplier.accounting}
                        onChange={(e) => handleOnChange(e, "input", "accounting")}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name="bypassAccounting"
                        className="mb-3"
                        charLimit={20}
                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης"
                        label="Κωδικός Λογαριασμού Παράκαμψης"
                        value={newSupplier.bypassAccounting}
                        onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default NewSupplierAccounting;